import { render, staticRenderFns } from "./BezahlungWeiterleitenBestellung.vue?vue&type=template&id=fbf91494"
import script from "./BezahlungWeiterleitenBestellung.vue?vue&type=script&lang=ts"
export * from "./BezahlungWeiterleitenBestellung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports